module.exports = __webpack_public_path__ + "static/dotnet-059be7df197bee64ff3b8c6a606b6e1b.png";